<template>
  <v-container
    fluid
    class="d-flex justify-center align-center"
    pa-md-4
    pa-2
    style="min-height: 10vh; border-radius: 0; overflow: auto"
  >
    <v-row class="d-flex justify-center">
      <v-col cols="12" sm="6" md="4" lg="10">
        <v-card rounded="0">
          <v-toolbar flat dense color="#005F95">
            <div>
              <!-- Small to Large Screens -->
              <h1
                class="Limit-Toolbar"
                :style="{
                  fontSize: isSmall ? '11px' : isMedium ? '16px' : '20px',
                }"
              >
                DINERS CLUB {{ product }} ONLINE APPLICATION
              </h1>
            </div>
          </v-toolbar>

          <v-form
            ref="cardDeliveryForm"
            v-model="validcarddelivery"
            lazy-validation
          >
            <v-container
              fluid
              style="border: 1px solid #ccc; border-radius: 0; padding: 16px"
            >
              <v-container fluid style="border-radius: 0; padding: 16px">
                <v-row>
                  <v-col cols="12">
                    <h1 class="Credit-Limit-Approve" style="text-align: left">
                      {{ product }} DELIVERY
                    </h1>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="5">
                    <v-radio-group
                      v-model="carddevopt"
                      hide-details
                      @change="clearData"
                    >
                      <v-radio value="cardholder" color="#005F95">
                        <template v-slot:label>
                          <span id="checkboxLabel">
                            I will be receiving this card. Note: Please have
                            your ID and Proof of Residence with you.
                          </span>
                        </template>
                      </v-radio></v-radio-group
                    >

                    <v-radio-group
                      v-model="carddevopt"
                      hide-details
                      @change="clearData"
                    >
                      <v-radio value="thirdparty" color="#005F95">
                        <template v-slot:label>
                          <span id="checkboxLabel">
                            An authorised third party will be receiving this
                            card. Note: Please ensure the person receiving the
                            card has the following: ▪ A signed letter providing
                            authority to collect. ▪ An ID copy of the
                            Cardholder. ▪ Latest Proof of Residence of the
                            Cardholder. ▪ An ID copy of the person receiving the
                            card.
                          </span>
                        </template>
                      </v-radio></v-radio-group
                    >

                    <v-radio-group
                      v-model="carddevopt"
                      hide-details
                      @change="clearData"
                    >
                      <v-radio class="label" value="newaddress" color="#005F95">
                        <template v-slot:label>
                          <span id="checkboxLabel"
                            >Deliver to this address</span
                          >
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-col>

                  <v-col cols="12" sm="4"></v-col>

                  <v-col
                    v-if="cardImageInfo"
                    cols="12"
                    sm="3"
                    md="3"
                    lg="3"
                    xl="3"
                  >
                    <img
                      class="cardimage"
                      :src="cardImageInfo.src"
                      :alt="cardImageInfo.alt"
                    />
                  </v-col>
                </v-row>

                <v-row v-if="carddevopt === 'thirdparty'">
                  <v-col cols="12">
                    <h3 style="text-align: left" class="Loyalty-Details">
                      AUTHORIZED THIRD PARTY DETAILS:
                    </h3>
                  </v-col>
                </v-row>

                <v-row v-if="carddevopt === 'newaddress'">
                  <v-col cols="12">
                    <h3 style="text-align: left" class="Loyalty-Details">
                      DELIVERY ADDRESS DETAILS:
                    </h3>
                  </v-col>
                </v-row>

                <v-row v-if="carddevopt === 'thirdparty'">
                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="txtname"
                      label="Full Name"
                      :rules="[
                        validateField(textFieldRegex, 'Please enter text only'),
                      ]"
                      maxlength="100"
                      counter
                      @keyup="uppercaseaddress"
                      required
                      clearable
                      color="#005F95"
                      variant="underlined"
                      density="comfortable"
                      prepend-icon="mdi-account"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="txtSaIdNumber"
                      label="Identity Number"
                      :rules="[validateSouthAfricanID]"
                      maxlength="13"
                      counter
                      type="text"
                      color="#005F95"
                      variant="underlined"
                      density="comfortable"
                      prepend-icon="mdi-account-details"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="txtcellNumber"
                      label="Contact Number"
                      :rules="[
                        validateField(
                          contactFieldRegex,
                          'Invalid Contact Number'
                        ),
                      ]"
                      required
                      clearable
                      counter
                      maxlength="10"
                      type="tel"
                      color="#005F95"
                      prepend-icon="mdi-phone"
                      variant="underlined"
                      density="comfortable"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row v-if="carddevopt === 'newaddress'">
                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="txtStreet"
                      label="Street Number and Name"
                      :rules="[
                        validateField(
                          alphaNumericFieldRegex,
                          'Please enter text only'
                        ),
                      ]"
                      maxlength="50"
                      counter
                      @keyup="uppercaseaddress"
                      required
                      autocomplete="on"
                      clearable
                      placeholder=""
                      color="#005F95"
                      prepend-icon="mdi-map-marker"
                      variant="underlined"
                      density="comfortable"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="txtSuburb"
                      label="Suburb"
                      :rules="[
                        validateField(textFieldRegex, 'Please enter text only'),
                      ]"
                      maxlength="50"
                      counter
                      @keyup="uppercaseaddress"
                      required
                      clearable
                      autocomplete="address-level2"
                      placeholder=""
                      color="#005F95"
                      prepend-icon="mdi-city"
                      variant="underlined"
                      density="comfortable"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="txtCity"
                      label="City / Town"
                      :rules="[
                        validateField(textFieldRegex, 'Please enter text only'),
                      ]"
                      maxlength="50"
                      counter
                      @keyup="uppercaseaddress"
                      required
                      clearable
                      autocomplete="address-level2"
                      placeholder=""
                      color="#005F95"
                      prepend-icon="mdi-city"
                      variant="underlined"
                      density="comfortable"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row v-if="carddevopt === 'newaddress'">
                  <v-col cols="12" sm="4">
                    <v-select
                      v-model="dropdownprovince"
                      :items="dropdown_province"
                      color="#005F95"
                      label="Province"
                      required
                      clearable
                      placeholder=""
                      variant="underlined"
                      density="comfortable"
                      prepend-icon="mdi-map"
                    ></v-select>
                  </v-col>

                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="txtCode"
                      label="Postal Code"
                      :rules="[
                        validateField(
                          numericFieldRegex,
                          'Please enter text only'
                        ),
                      ]"
                      maxlength="4"
                      counter
                      mask="####"
                      required
                      clearable
                      autocomplete="postal-code"
                      placeholder="Enter Postal Code"
                      type="text"
                      color="#005F95"
                      variant="underlined"
                      density="comfortable"
                      prepend-icon="mdi-home"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row v-if="carddevopt === 'newaddress'">
                  <v-col cols="12">
                    <h3 style="text-align: left">
                      Your Selected Delivery Address: [{{
                        txtStreet +
                        " - " +
                        txtSuburb +
                        " - " +
                        txtCity +
                        " - " +
                        dropdownprovince +
                        " - " +
                        txtCode
                      }}]
                    </h3>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col style="text-align: center">
                    <v-btn
                      color="#005F95"
                      class="text-white"
                      style="border-radius: 0; width: 170px; height: 30px"
                      @click="cardDelivery()"
                      :loading="isLoading"
                      :disabled="!isCardDeliveryDetailsFormValid"
                    >
                      <span v-if="!isLoading">CONTINUE</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-container>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
/* eslint-disable */
import { useDisplay } from "vuetify/lib/framework.mjs";
import { ref, onBeforeMount, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import axios from "axios"; // Import axios if not globally available

const { smAndDown, mdAndUp, lgAndUp } = useDisplay();
const isSmall = smAndDown;
const isMedium = computed(() => mdAndUp.value && !lgAndUp.value);
const validcarddelivery = ref("");
const product = ref("");
const prodtype = ref("");
const apptype = ref("");
const appStatus = ref("");
const refNumber = ref("");
const authToken = sessionStorage.getItem("authToken");
const router = useRouter();
const isLoading = ref(false);
const BeyondSelected = ref(false);
const UserID = ref("");
const carddevopt = ref("");
const txtname = ref("");
const txtSaIdNumber = ref("");
const txtcellNumber = ref("");
const txtStreet = ref("");
const txtSuburb = ref("");
const txtCity = ref("");
const dropdownprovince = ref("");
const txtCode = ref("");
const today = new Date().toISOString().split("T")[0];
const dropdown_province = ref([
  "EASTERN CAPE",
  "FREE STATE",
  "GAUTENG",
  "KWAZULU-NATAL",
  "LIMPOPO",
  "MPUMALANGA",
  "NORTH WEST",
  "NORTHERN CAPE",
  "WESTERN CAPE",
]);

// Reusable validateField rule generator:
const validateField = (pattern, errorMessage) => {
  return (v) => {
    if (!v) return "This field is required";
    return pattern.test(v) || errorMessage;
  };
};

// Regex Patterns
const textFieldRegex = /^[A-Za-z\s]+$/;
const textFieldSpaceRegex = /^[ A-Za-z0-9_@./#&+-]*$/;
const textFieldHyphenRegex = /^[a-zA-Z\- s]+$/;
const alphaNumericFieldRegex = /^[a-zA-Z0-9\- s]+$/;
const numericFieldRegex = /^[0-9]*$/;
const contactFieldRegex = /^[0-9]{10}$/;
const emailAddressRegex = /^[\w-\.]+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}/;
const identityNumberRegex =
  /(((\d{2}((0[13578]|1[02])(0[1-9]|[12]\d|3[01])|(0[13456789]|1[012])(0[1-9]|[12]\d|30)|02(0[1-9]|1\d|2[0-8])))|([02468][048]|[13579][26])0229))(( |-)(\d{4})( |-)(\d{3})|(\d{7}))/;

//RSA ID Validator Function (Regex + DOB + Citizenship + Luhn)
function isValidSouthAfricanID(id) {
  if (!/^\d{13}$/.test(id)) return false;

  const year = parseInt(id.slice(0, 2), 10);
  const month = parseInt(id.slice(2, 4), 10);
  const day = parseInt(id.slice(4, 6), 10);
  const fullYear = year >= 0 && year <= 49 ? 2000 + year : 1900 + year;

  const date = new Date(`${fullYear}-${month}-${day}`);
  if (
    isNaN(date.getTime()) ||
    date.getFullYear() !== fullYear ||
    date.getMonth() + 1 !== month ||
    date.getDate() !== day
  )
    return false;

  const citizenship = parseInt(id.charAt(10), 10);
  if (citizenship !== 0 && citizenship !== 1) return false;

  let sum = 0;
  for (let i = 0; i < 12; i++) {
    let digit = parseInt(id.charAt(i), 10);
    if (i % 2 === 0) {
      sum += digit;
    } else {
      let doubled = digit * 2;
      sum += doubled > 9 ? doubled - 9 : doubled;
    }
  }

  const checkDigit = parseInt(id.charAt(12), 10);
  return (sum + checkDigit) % 10 === 0;
}

function validateSouthAfricanID(value) {
  if (!value) return true;
  return (
    isValidSouthAfricanID(value) ||
    "Please enter a valid South African ID number."
  );
}

//Form Field Validations - OTP Form
const isCardDeliveryDetailsFormValid = computed(() => {
  if (carddevopt.value === "thirdparty") {
    return (
      txtname.value?.trim() &&
      txtSaIdNumber.value?.trim() &&
      txtcellNumber.value?.trim()
    );
  } else if (carddevopt.value === "newaddress") {
    return (
      txtStreet.value?.trim() &&
      txtSuburb.value?.trim() &&
      txtCity.value?.trim() &&
      txtCode.value?.trim() &&
      dropdownprovince.value &&
      carddevopt.value?.trim()
    );
  } else {
    return carddevopt.value;
  }
});

// Product Card Image Vitualization
const cardImageInfo = computed(() => {
  const mapping = {
    beyond: {
      src: require("@/assets/images/beyond.png"),
      alt: "Beyond Card",
    },
    platinum: {
      src: require("@/assets/images/creditc.png"),
      alt: "Platinum Card",
    },
    shariah: {
      src: require("@/assets/images/shariah.png"),
      alt: "Sharia'h Card",
    },
  };
  return mapping[prodtype.value] || null;
});

onBeforeMount(() => {
  // Get appStatus from session storage
  appStatus.value = sessionStorage.getItem("appStatus");
  prodtype.value = sessionStorage.getItem("prodtype");
  apptype.value = sessionStorage.getItem("apptype");

  if (apptype.value === "newapp") {
    refNumber.value = sessionStorage.getItem("refNumber");
  } else if (apptype.value === "continueapp") {
    refNumber.value = sessionStorage.getItem("incompleteRef");
  }

  // Redirect if application is in a final state
  if (["Declined", "Approved", "Referred"].includes(appStatus.value)) {
    router.push("/");
    return;
  }

  // Get product type from session storage

  const productMap = {
    platinum: "CREDIT CARD",
    shariah: "SHARI'AH CARD",
  };
  product.value = productMap[prodtype.value] || "BEYOND CARD";
  BeyondSelected.value =
    prodtype.value !== "platinum" && prodtype.value !== "shariah";

  // Handle reference number logic

  if (refNumber.value) {
    UserID.value = sessionStorage.getItem("userid");
    // getLoyaltyDetails();
    // updateappStatus();
  } else {
    router.push("/");
  }
});

const uppercaseaddress = () => {
  txtname.value = txtname.value.toUpperCase();
  txtStreet.value = txtStreet.value.toUpperCase();
  txtSuburb.value = txtSuburb.value.toUpperCase();
  txtCity.value = txtCity.value.toUpperCase();
};

const clearData = () => {
  if (carddevopt.value == "thirdparty") {
    txtname.value = "";
    txtSaIdNumber.value = "";
    txtcellNumber.value = "";
  } else if (carddevopt.value == "newaddress") {
    txtStreet.value = "";
    txtSuburb.value = "";
    txtCity.value = "";
    dropdownprovince.value = "";
    txtCode.value = "";
  }
};

const cardDelivery = async () => {
  const authToken = sessionStorage.getItem("authToken");
  const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  isLoading.value = true;

  if (!refNumber.value || !authToken) {
    console.log("User not Authorized");
    isLoading.value = false;
    return;
  }
  try {
    isLoading.value = true;

    const response = await axios.post(
      "/cardDelivery",
      {
        _REFNUMBER: refNumber.value,
        _CARDDELIVOPT: carddevopt.value,
        _NAME: txtname.value,
        _IDNUMBER: txtSaIdNumber.value,
        _CONTACTNUM: txtcellNumber.value,
        _STREETNAMENO: txtStreet.value,
        _SUBURB: txtSuburb.value,
        _CITY: txtCity.value,
        _PROVINCE: dropdownprovince.value,
        _POSTCODE: txtCode.value,
      },
      {
        headers: {
          Authorization: authToken,
        },
      }
    );

    isLoading.value = false;

    if (response.status !== 200) {
      router.push("/TechnicalError");
    } else if (["UPDATED", "ADDED"].includes(response.data.data._RESPONSE)) {
      router.push("/CompletedApp");
      await delay(10000); // ⏳ wait 30 seconds
      sendCustomerDocs();
      
    }
  } catch (error) {
    console.error("Error in cardDelivery:", error);
    isLoading.value = false;
    router.push("/TechnicalError");
  }
};

const formatDateYYYYMMDD = (date) => {
  return date
    ? new Date(date).toISOString().split("T")[0].replace(/-/g, "")
    : "";
};
const updateappStatus = async () => {
  const authToken = sessionStorage.getItem("authToken");
  // const userId = sessionStorage.getItem("userid");

  if (!refNumber.value || !authToken) {
    console.log("Customer Reference Number or Auth Token Not Found");
    return;
  }

  try {
    isLoading.value = true;

    const response = await axios.post(
      "/updateappStatus",
      {
        _REFNUMBER: refNumber.value,
        _USER_ID: UserID.value,
        _STATUS: "Approved",
        _STATUSDATE: formatDateYYYYMMDD(today),
      },
      {
        headers: {
          Authorization: authToken,
        },
      }
    );

    isLoading.value = false;

    if (["UPDATED", "ADDED"].includes(response.data.data._RESPONSE)) {
      // Uncomment if needed:
      // router.push('/CompletedApp');
    }
  } catch (error) {
    console.error("Error in updateappStatus:", error);
    isLoading.value = false;
  }
};

//Function To Pass Auth Token To The Headers
const axiosConfig = {
  headers: {
    Authorization: authToken,
  },
};
const sendCustomerDocs = () => {
  const clientNames = `${sessionStorage.getItem(
    "paqfirstname"
  )} ${sessionStorage.getItem("paqlastname")}`;
  const destEmail = sessionStorage.getItem("userid");

  if (!refNumber.value) {
    console.log("Customer Reference Number Was Not Found");
    return;
  }

  // Send /sendPAQEmail immediately
  axios
    .post(
      "/sendPAQEmail",
      {
        clientNames,
        fromEmail: "",
        destEmail,
        subjectLine: "",
        clientref: refNumber.value,
        clientReplyEmail: "",
        clientTelephone: "",
        clientMessageText: "",
        producttype: prodtype.value,
      },
      axiosConfig
    )
    .catch((error) => {
      console.log(error);
    });

  // Send /sendTCsEmail after 10 seconds
  setTimeout(() => {
    axios
      .post(
        "/sendTCsEmail",
        {
          clientNames,
          fromEmail: "",
          destEmail,
          subjectLine: "",
          clientref: refNumber.value,
          clientReplyEmail: "",
          clientTelephone: "",
          clientMessageText: "",
          producttype: prodtype.value,
        },
        axiosConfig
      )
      .catch((error) => {
        console.log(error);
      });
  }, 10000);

  // Send /sendMembershipEmail after 10 seconds
  setTimeout(() => {
    axios
      .post(
        "/sendMembershipEmail",
        {
          clientNames,
          fromEmail: "",
          destEmail,
          subjectLine: "",
          clientref: refNumber.value,
          clientReplyEmail: "",
          clientTelephone: "",
          clientMessageText: "",
          producttype: prodtype.value,
        },
        axiosConfig
      )
      .catch((error) => {
        console.log(error);
      });
  }, 10000);
};
</script>

<style>
.cardimage {
  max-width: 100%;
  max-height: 100%;
  align-items: left;
}
@font-face {
  font-family: "GathamLight";
  src: url("@/assets/fonts/Gotham-Light.woff2") format("woff2"),
    url("@/assets/fonts/Gotham-Light.otf") format("opentype");
  font-display: swap;
}
#checkboxLabel {
  font-family: "GathamLight";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #041e42;
}
label {
  font-family: "GathamLight";
  color: #041e42;
}
</style>
